import React from 'react';

export default ({ url }) => {
    location.href = url;

    return <></>
}
